// Talks to GET /api/v1/user/info. Called after sign-in to fetch the user's profile, which the backend
// enriches from Microsoft Graph /me via an On-Behalf-Of exchange. The caller supplies the API bearer +
// identity hints (same shape as chatClient/settingsClient).
import { authHeaders, type AuthArgs } from './authArgs';

export interface UserInfo {
  cid?: string | null;
  givenName?: string | null;
  surname?: string | null;
  email?: string | null;
  displayName?: string | null;
  provider?: string | null;
  tenantId?: string | null;
  userPuid?: string | null;
  graphEnriched: boolean;
  /** Permission names granted to the user (from the SQL identity schema). Drives navigation & admin. */
  permissions: string[];
}

export async function getUserInfo(args: AuthArgs, signal?: AbortSignal): Promise<UserInfo> {
  const res = await fetch('/api/v1/user/info', { method: 'GET', headers: authHeaders(args), signal });
  if (!res.ok) {
    throw new Error(`user info ${res.status}: ${await res.text()}`);
  }
  return (await res.json()) as UserInfo;
}
